import { Component, OnInit } from '@angular/core';
import {UserService} from "../../services/user.service";
import {User} from "../../models/user";
import {environment} from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-descuentos',
  templateUrl: './descuentos.component.html',
  styleUrls: [
    './descuentos.component.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css'
  ],
  providers: [UserService]
})
export class DescuentosComponent implements OnInit {
  public user : User;
  public identity;
  public token;
  public descuentos;
  public descuentosAsociado;
  public total;
  actual = environment.actual;
  public colorFondo = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public descuentosConfig
  public mobile

  constructor(
    private _userService: UserService,
    private spinner: NgxSpinnerService
  ) {
    this.user = new User(1,  '',  '',  '',  '',  '',  '', 0, 0);
  }

  ngOnInit() {
    this.spinner.show();
    this.identity =JSON.parse(this._userService.GetsessionStorage('identity'));
    this.descuentosConfig = JSON.parse(this._userService.GetsessionStorage('config'));
    this.consultarDescuentos();

    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
  }

  decodeBuffer(arraybuffer?) {
    if(arraybuffer != null) {
      return String.fromCharCode.apply(null, new Uint16Array(arraybuffer));
    }
  }

  consultarDescuentos(){
    this._userService.httpGet('descuentos/'+this.identity.NIT).subscribe(
      response =>{
        //devuelve token
        this.descuentosAsociado = response.details;

        //Calculamos el TOTAL
        this.total = this.descuentosAsociado.reduce((
            acc: number,
            obj,
            ) => acc + parseFloat(obj.TOTAL),
            0);
        //console.log("Total: ", this.total)
        this.spinner.hide();
      },
      error =>{
        console.log(<any>error);
        this.spinner.hide();
      }
    );
  }

}
